import type { EminenceFlags } from "./Database/eminence";
import { getFeatureSetting } from "./feature-settings";

export function supportsOfflineActionQueue(eminenceFlags: EminenceFlags): boolean {
    if (!getFeatureSetting("offlineMode")) return false;
    return eminenceFlags.offlineActionQueue || getFeatureSetting("offlineActionQueueForEverybody");
}
